import { useCallback } from "react";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { useRemoteDataMutation } from "src/hooks/useRemoteDataMutation";
import * as GQL from "src/types/graphql";
import { UPDATE_FORM_VISIBILITY_BY_ID } from "../graphql/mutations";
import { GET_FORM_VIEW_BY_ID } from "../graphql/queries";
import { SetVisibilityMenu } from "./SetVisibilityMenu";
import { trackFormAction, trackFormActionError } from "./trackFormAction";

interface SetVisibilityMenuSingleProps {
  formVisibility: boolean | null;
  formId: string;
}

export function SetVisibilityMenuSingle({
  formVisibility,
  formId,
}: SetVisibilityMenuSingleProps) {
  const toast = useAvelaToast();
  const [UpdateFormVisibilityById] = useRemoteDataMutation<
    GQL.UpdateFormVisibilityById,
    GQL.UpdateFormVisibilityByIdVariables
  >(UPDATE_FORM_VISIBILITY_BY_ID, { refetchQueries: [GET_FORM_VIEW_BY_ID] });

  const handleVisibilityChange = useCallback(
    async (visibility: boolean) => {
      try {
        await UpdateFormVisibilityById({
          variables: {
            form_id: formId,
            visibility: visibility,
          },
        });

        if (!toast.isActive(formId)) {
          toast({
            id: formId,
            title: "Visibility updated",
            isClosable: true,
          });
        }
        trackFormAction({
          verb: "Completed",
          actionType: "SET_FORM_VISIBILITY",
          bulk: false,
          count: 1,
          async: false,
          extra: { visibility },
        });
      } catch (error) {
        console.error(error);
        trackFormActionError(error, {
          actionType: "SET_FORM_VISIBILITY",
          bulk: false,
          count: 1,
          async: false,
          extra: { visibility },
        });
        if (!toast.isActive(formId)) {
          toast({
            id: formId,
            title: "Error updating visibility",
            status: "error",
            isClosable: true,
          });
        }
      }
    },
    [UpdateFormVisibilityById, formId, toast]
  );
  return (
    <SetVisibilityMenu
      formVisibility={formVisibility}
      onVisibilityChange={handleVisibilityChange}
    />
  );
}
